@if (!isExperts) {
  <mb-badge
    size="small"
    color="light"
    class="provider-description"
    (click)="openModalProvider()"
  >
    <mb-icon class="icon" icon="info"></mb-icon>
    <span class="text"> Provider</span>
  </mb-badge>
} @else {
  <mb-badge size="small" color="light" class="provider-description" (click)="openModalProvider()">
    <span class="text">{{ cluster?.rates[0].provider }}</span>
  </mb-badge>
}
